export default __webpack_public_path__ + "profile-placeholder.0dbc829.png";